// extracted by mini-css-extract-plugin
export default {"container":"SupplierFormPage_container__kFI7e"};